import { render, staticRenderFns } from "./uploadImgPage.vue?vue&type=template&id=19b5aaac&scoped=true&"
import script from "./uploadImgPage.vue?vue&type=script&lang=js&"
export * from "./uploadImgPage.vue?vue&type=script&lang=js&"
import style0 from "./uploadImgPage.vue?vue&type=style&index=0&id=19b5aaac&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b5aaac",
  null
  
)

export default component.exports